import { Flex, ValidationText } from '@utilitywarehouse/hearth-react';
import { FC } from 'react';

import './styles.scss';

interface BundleAlertProps {
  showAlert: boolean;
  alertMessage: string;
  errorRef: React.RefObject<HTMLDivElement | null>;
}

const BundleAlert: FC<BundleAlertProps> = ({
  showAlert,
  alertMessage,
  errorRef,
}) => {
  if (!showAlert) return null;

  return (
    <Flex
      data-testid="bundle-alert"
      className="bundle-legal__alert"
      ref={errorRef}
    >
      <ValidationText ref={errorRef} status="invalid">
        {alertMessage}
      </ValidationText>
    </Flex>
  );
};

export { BundleAlert };
